/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Pranay Patel",
  title: "Hi all, Pranay",
  subTitle: emoji(
    "Software Architect | Lead Engineer - Android/Flutter | PROMPTING..., Tech savvy | Investor | Mentor. With over 9 years in Mobile development. I build products and solutions that solve users problems! Proficient in leveraging AI tools to enhance coding efficiency and drive innovation in app development. Passionate about mentoring engineers."
  ),
  resumeLink:
    "https://app.enhancv.com/share/a9640c85/", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/pranaypatel512",
  linkedin: "https://www.linkedin.com/in/pranaypatel512/",
  gmail: "iampranaypatel@gmail.com",
  medium: "https://pranaypatel.medium.com/",
  stackoverflow: "https://stackoverflow.com/users/2949612/pranay",
  twitter: "https://x.com/pranaypatel_",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "I have experience in working with Android, Kotlin Multiplatform(KMP) and Flutter technologies.",
  skills: [
    emoji(
      "⚡ Taking on the role of a mentor, I leverage my experience to guide and uplift junior colleagues."
    ),
    emoji(
      "⚡ Besides my technical skills, I have a strong background in team management and leadership. I've been able to guide teams to complete projects on time."
    ),
    emoji("⚡ My recent endeavors include delving into AWS and discovering the world of static website generation."),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Kotlin",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fab fa-flutter"
    },
    {
      skillName: "Jetpack Compose",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Kotlin MultiPlatform",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Ganpat University, Kherva",
      logo: require("./assets/images/ganpat_uni.jpg"),
      subHeader: "Msc(CA&IT)",
      duration: "Jan 2013 - Dec 2015",
      desc: "I have a gold medal in my master's degree.",
    },{
      schoolName: "Ganpat University, Kherva",
      logo: require("./assets/images/ganpat_uni.jpg"),
      subHeader: "Bsc(CA&IT)",
      duration: "Jan 2010 - Dec 2013",
      desc: "I have a gold medal in my bachelor's degree.",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Android", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Kotlin",
      progressPercentage: "80%"
    },
    {
      Stack: "Jetpack Compose",
      progressPercentage: "70%"
    },
    {
      Stack: "Kotlin MultiPlatform",
      progressPercentage: "50%"
    },
    {
      Stack: "Git",
      progressPercentage: "80%"
    },
    {
      Stack: "Firebase",
      progressPercentage: "80%"
    },
    {
      Stack: "Leadership",
      progressPercentage: "75%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [{
      role: "Senior Software Engineer (Consultant)",
      company: "7Span",
      companylogo: require("./assets/images/7span.jpg"),
      date: "August 2024 — Present",
      descBullets: [
       "Led Android development on multiple key projects, actively contributing to planning and feature implementation during development cycles.",
"Spearheaded the setup of GitHub action flows, optimizing workflow efficiency across projects.",
"Played a key role in developing a foundational project structure plugin, streamlining project initiation processes.",
"Provided mentorship to junior developers by establishing effective onboarding frameworks and project setup guidelines, fostering team growth and efficiency."
      ]
    },
    {
      role: "Senior Software Engineer - Android",
      company: "Mutual Mobile Solutions Pvt. Ltd",
      companylogo: require("./assets/images/mutualmobile_logo.jpeg"),
      date: "August 2022 — July 2024",
      descBullets: [
        "Successfully contributed to 3 intricate projects, demonstrating adaptability. Also assumed a leadership role for 2 projects, spearheading Android development to drive project success with other team members.",
        "Worked on the setup of GitHub action flows for projects, optimizing workflow efficiency.",
        "Collaborated within an internal team to develop a foundational project structure plugin, streamlining project initiation processes.",
        "Engaged in a mentorship program, providing guidance and expertise on various topics to fellow team members.",
      ]
    },
    {
      role: "Senior Software Engineer – Android",
      company: "Superpro.ai",
      companylogo: require("./assets/images/superproai_logo.jpeg"),
      date: "September 2021 — July 2022",
      descBullets: [
        "We are developing product collaboratively with other platform team to target our audience.",
        "Leading on android side related to our product requirement, sharing idea to improve product or design new features along with preparing some POC related to video calling app.",
        "Working with other team members on Android project to maintain code quality and feature development along with performing code reviewer role.",
        "Along with development working on CI/CD tools to make things automated."
      ]
    },{
      role: "Senior Software Engineer – Android",
      company: "Simform Solutions Pvt Ltd",
      companylogo: require("./assets/images/simform_logo.jpeg"),
      date: "May 2018 — August 2021",
      descBullets: [
        "Working together with cross-functional platform teams to create Android applications and meet development objectives collaboratively.",
        "Examining initial project requirements to provide preliminary project estimates and creating necessary proof of concept (POC).",
        "Guiding junior and mid-level engineers in establishing project frameworks and initiating project work.",
        "Fulfilling the role of a code reviewer for select Android projects to ensure the upkeep of code quality."
      ]
    },
    {
      role: "Software Engineer – Android",
      company: "LetsNurture Infotech Pvt Ltd",
      companylogo: require("./assets/images/letsnurture_logo.jpeg"),
      date: "January 2015 — April 2018",
      descBullets: [
        "Developing apps are based on a REST API and Oauth2. Work on the client and server-side of the project using the latest technical solutions for each platform using design patterns like MVP and MVVM.",
        "Project Lead for 2 projects and managed project team including Web, Mobile, Design & QA team"
      ]
    },

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "PROJECTS",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/SNB.webp"),
      projectName: "NEO by The Saudi National Bank (SNB)",
      projectDesc: "NEO is a lifestyle banking and a financial ecosystem that enables your ambitions at every step for all of life’s moments.This is a digital bank that grows with you.",
      footerLink: [
        {
          name: "PlayStore Link",
          url: "https://play.google.com/store/apps/details?id=com.snb.neo&hl=en_IN&pli=1"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/medcheck.webp"),
      projectName: "MedCheck",
      projectDesc: "MedCheck App connects to MedCheck blood pressure monitors and blood glucose monitors via Bluetooth. It records medication, height, weight, and other notes, to make sense of disjointed data so users can start to play an active role in their own healthcare.",
      footerLink: [
        {
          name: "PlayStore Link",
          url: "https://play.google.com/store/apps/details?id=com.getmedcheck"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/1721318097297.jpeg"),
      projectName: "BassForecast: Fishing Forecast",
      projectDesc: "BassForecast uses science to predict bass feeding times, analyzing weather, water data, and moon phases with our exclusive BassForecast Rating (BFR) system. It's like having a personal bass fishing forecast in your pocket!",
      footerLink: [
        {
          name: "PlayStore Link",
          url: "https://play.google.com/store/apps/details?id=com.bassforecast.android&hl=en_US"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/1721317905068.jpeg"),
      projectName: "Hello Eyes",
      projectDesc: "The Hello Eyes app puts the power of an optical shop in your hands. You can access lens scanning, pupillary distance (PD) calculations, and vision exam technology in one convenient place.",
      footerLink: [
        {
          name: "PlayStore Link",
          url: "https://play.google.com/store/apps/details?id=co.helloeyes.mobileapp&hl=en"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Realest.webp"),
      projectName: "Realest - Real Estate Agent",
      projectDesc: "Realest is a powerful organisation app for estate agents.",
      footerLink: [
        {
          name: "PlayStore Link",
          url: "https://play.google.com/store/apps/details?id=com.roundr.app&hl=en_us"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Make your code shine with Static Analysis and SonarQube",
      subtitle: "DevFest Ahmedabad 2022 Talk",
      slides_url: "https://docs.google.com/presentation/d/14DIDN-Hc9r5g2ZuCfWLwLUNDcmlrNDuzuAYMYGZnO8g/edit?usp=sharing",
      event_url: "https://devfest.gdgahmedabad.com/previous-speakers/pranay_patel"
    },
    {
      title: "CameraX - Android camera in simple way!",
      subtitle: "DevFest Ahmedabad 2019 Talk",
      slides_url: "https://speakerdeck.com/pranaypatel512/android-camerax-devfestahm-2019",
      event_url: "https://devfest.gdgahmedabad.com/previous-speakers/pranay_patel"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7990139255",
  email_address: "iampranaypatel@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "pranaypatel_", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
